import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useEmployeeActivate = createUseMutationHook(
    'employee_activate',
    companyId => [
        ['employee_list', companyId],
    ],
);
